import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LocalDate } from '../../model/local-date';

export const ASTRAL_MAX_DATE = '9999-12-31';
export const ASTRAL_MAX_DATE_TIME = '9999-12-31T23:59';
export const ASTRAL_MAX_YEAR = 9999;

export const astralSupportedYearValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const year = getYear(control?.value);
  if (year === null || (Number.isInteger(year) && year >= 1 && year <= ASTRAL_MAX_YEAR)) {
    return null;
  }

  return {
    astralDateYear: {
      message: 'ERROR.DATE',
      params: {},
    },
  };
};

function getYear(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof LocalDate) {
    return value.hasValue() ? value.year : null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? Number.NaN : value.getFullYear();
  }

  if (typeof value === 'string') {
    const match = value.match(/^([+-]?\d+)-/);
    return match ? Number(match[1]) : Number.NaN;
  }

  if (typeof value === 'object' && 'year' in value) {
    const year = (value as { year?: unknown }).year;
    return year === null || year === undefined || year === '' ? null : Number(year);
  }

  return null;
}
